import styled from 'styled-components';

export const InputContainer = styled.div<{ isCheckobox?: boolean }>`
  margin: 10px 0;
  height: ${({ isCheckobox }) => (isCheckobox ? 'auto' : '50px')};
`;
